module.exports = __webpack_public_path__ + "static/media/Jacqueline-Killian_160px.ab814222.jpg";